/* eslint-env browser */
import CookieMonster from '@firstandthird/cookie-monster';
import { fire } from 'domassist';

export default function () {
  const CookieName = 'pdat-page';
  const current = CookieMonster.get(CookieName);

  // If already happened, discard
  if (current && current.logged) {
    return;
  }

  // First page view
  if (!current || !current.first) {
    CookieMonster.set(CookieName, {
      first: location.pathname
    }, 365);
  } else {
    // Are they different ?
    if (current.first !== location.pathname) {
      fire(document.body, 'pdat:log', {
        detail: {
          label: 'page',
          action: `${current.first} - ${location.pathname}`
        }
      });

      // Avoid from logging twice
      current.logged = true;
      CookieMonster.set(CookieName, current);
    }
  }
}
